// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"scroll_wrapper__3TXnJ"};